<template>
  <div class="flex gap-4">
    <Link href="/impressum" target="_blank" class="link">Impressum</Link>
    <a href="/datenschutzerklaerung/" class="link">Datenschutz</a>
  </div>
</template>

<script>
import {Link} from '@inertiajs/inertia-vue3'

export default {
  name: 'DgvtLegal',

  components: {
    Link,
  },
}
</script>

<style scoped>

</style>